import { InquiryUploader } from 'inquiries';
import { h } from 'preact';
import { HopplerModal, HopplerModalProps } from '../../common/hoppler-modal-component';

interface ContactUploaderModalProps extends HopplerModalProps  {
  uploader: InquiryUploader;
  onClose: () => void;
}

interface ContactUploaderModalState {}

export class ContactUploaderModal extends HopplerModal<ContactUploaderModalProps, ContactUploaderModalState> {

  constructor() {
    super();
  }

  doModalClose = () => {}

  render(props: ContactUploaderModalProps, state: ContactUploaderModalState) {
    return this.modalize(
      <section className="hi-inqconupmodal">
        <div className="hi-inqconupmodal__title-bar">
          <span className="hi-inqconupmodal__title-label">Contact Uploader</span>
          <button onClick={ props.onClose } 
            className="btn btn-link hi-inqconupmodal__title-close">
            <i className="fas fa-times" /> close
          </button>
        </div>

        <div className="hi-inqconupmodal-details">
          <img 
            src="http://via.placeholder.com/80x80"
            className="rounded-circle mb-2" 
            alt=""/>

          <p className="uploader-name">{ props.uploader.uploaderName }</p>
          <p className="uploader-source">{ props.uploader.source }</p>
        </div>

        <div className="hi-inqconupmodal-number">
          <p className="mb-0">Want to make a call?</p>
          <p>Just click the number below</p>
          <a 
            className="button-link"
            href={ `tel:${props.uploader.uploaderMobile}` }>
            {props.uploader.uploaderMobile}
          </a>
        </div>

        <hr className="my-0"/>

        <div className="hi-inqconupmodal-email">
          <p className="mb-0">Want to send an email?</p>
          <p>Just click the email below</p>
          <a 
            className="button-link"
            href={ `mailto:${props.uploader.uploaderEmail}` }>
            { props.uploader.uploaderEmail }
          </a>
        </div>
        
      </section>
    ) 
  }
}